import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const InfoDashboard = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchInfo = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/admin/public');
        setInfo(res.data.info);
      } catch (err) {
        setError(err.response?.data?.message || 'Мэдээлэл авах үед алдаа гарлаа');
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, []);

  return (
    <div>
      <h2>Мэдээлэл самбар</h2>
      {loading && <div>Ачааллаж байна...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {info && (
        <div className="info-dashboard-grid">
          <div className="info-dashboard-card"><div className="info-dashboard-label">Нэр</div><div>{info.name || '-'}</div></div>
          <div className="info-dashboard-card"><div className="info-dashboard-label">Утас</div><div>{info.phone || '-'}</div></div>
          <div className="info-dashboard-card"><div className="info-dashboard-label">И-мэйл</div><div>{info.email || '-'}</div></div>
          <div className="info-dashboard-card"><div className="info-dashboard-label">Дэмжлэгийн и-мэйл</div><div>{info.supportEmail || '-'}</div></div>
          <div className="info-dashboard-card"><div className="info-dashboard-label">Банк</div><div>{info.bankName || '-'}</div></div>
          <div className="info-dashboard-card"><div className="info-dashboard-label">IBAN</div><div>{info.iban || '-'}</div></div>
          <div className="info-dashboard-card"><div className="info-dashboard-label">Дансны дугаар</div><div>{info.bankAccountNumber || '-'}</div></div>
        </div>
      )}
      <style>{`
        .info-dashboard-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 18px;
          margin-top: 8px;
        }
        .info-dashboard-card {
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 16px;
          background: #fafbfc;
          min-width: 0;
        }
        .info-dashboard-label {
          font-weight: 700;
          margin-bottom: 4px;
        }
        @media (max-width: 600px) {
          .info-dashboard-grid {
            grid-template-columns: 1fr;
            gap: 12px;
          }
          .info-dashboard-card {
            padding: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default InfoDashboard;
